// Backend connectivity test utility
import { getApiBaseUrl, getPublicApiUrl, logApiConfig } from './apiConfig';

export const testBackendConnectivity = async () => {
  console.log('🧪 Starting backend connectivity test...');
  logApiConfig();
  
  const tests = [];
  
  // Test 1: Health check
  try {
    const healthUrl = `${getApiBaseUrl().replace('/api', '')}/api/health`;
    console.log('🌡️ Testing health endpoint:', healthUrl);
    
    const healthResponse = await fetch(healthUrl);
    const healthData = await healthResponse.json();
    
    tests.push({
      name: 'Health Check',
      url: healthUrl,
      status: healthResponse.status,
      success: healthResponse.ok,
      data: healthData
    });
  } catch (error) {
    tests.push({
      name: 'Health Check',
      url: `${getApiBaseUrl().replace('/api', '')}/api/health`,
      status: 'ERROR',
      success: false,
      error: error.message
    });
  }
  
  // Test 2: Events endpoint
  try {
    const eventsUrl = `${getApiBaseUrl()}/events`;
    console.log('🎆 Testing events endpoint:', eventsUrl);
    
    const eventsResponse = await fetch(eventsUrl);
    const eventsData = await eventsResponse.json();
    
    tests.push({
      name: 'Events API',
      url: eventsUrl,
      status: eventsResponse.status,
      success: eventsResponse.ok,
      data: eventsData
    });
  } catch (error) {
    tests.push({
      name: 'Events API',
      url: `${getApiBaseUrl()}/events`,
      status: 'ERROR',
      success: false,
      error: error.message
    });
  }
  
  // Test 3: Registration config endpoint (if we have an event ID)
  try {
    // Try to get first event ID from events test
    const eventsTest = tests.find(t => t.name === 'Events API' && t.success);
    if (eventsTest && eventsTest.data?.events?.length > 0) {
      const firstEventId = eventsTest.data.events[0].id;
      const regConfigUrl = getPublicApiUrl(`events/${firstEventId}/registration-config`);
      console.log('📋 Testing registration config endpoint:', regConfigUrl);
      
      const regConfigResponse = await fetch(regConfigUrl);
      const regConfigData = await regConfigResponse.json();
      
      tests.push({
        name: 'Registration Config',
        url: regConfigUrl,
        status: regConfigResponse.status,
        success: regConfigResponse.ok,
        data: regConfigData
      });
    }
  } catch (error) {
    tests.push({
      name: 'Registration Config',
      url: 'N/A',
      status: 'ERROR',
      success: false,
      error: error.message
    });
  }
  
  // Summary
  const successfulTests = tests.filter(t => t.success).length;
  const totalTests = tests.length;
  
  console.log('🧪 Backend connectivity test results:');
  console.table(tests);
  console.log(`✅ ${successfulTests}/${totalTests} tests passed`);
  
  return {
    success: successfulTests === totalTests,
    successfulTests,
    totalTests,
    tests
  };
};

// Quick test function for debugging
export const quickTest = async () => {
  try {
    const result = await testBackendConnectivity();
    if (result.success) {
      console.log('🎉 All backend tests passed!');
    } else {
      console.warn(`⚠️ ${result.totalTests - result.successfulTests} tests failed`);
    }
    return result;
  } catch (error) {
    console.error('❌ Backend test failed:', error);
    return { success: false, error: error.message };
  }
};
